import { Routes, RouterModule } from "@angular/router";
import { VisitorComponent } from "./index";
import { VisitorDesignComponent } from "./visitordesign/visitordesign.component";
import { FacilityLocationMaintComponent } from "./facilitylocationmaint/facilitylocationmaint.component";
import { ViewLogComponent } from "./viewlog/viewlog.component";
import { ViewVisitorComponent } from "./viewvisitor/viewvisitor.component";
import { AuthguardService } from "../master/services";

export const VisitorRoutes: Routes = [
	{ path: "", redirectTo: "/visitor/passdesign", pathMatch: "full" },
	{
		path: "passdesign",
		data: { title: "Pass Designer" },
		component: VisitorDesignComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "location",
		data: { title: "Location Maintenance" },
		component: FacilityLocationMaintComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "viewlog",
		data: { title: "View Logs" },
		component: ViewLogComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "viewvisitor",
		data: { title: "View Visitors" },
		component: ViewVisitorComponent,
		canActivate: [AuthguardService],
	},
];
